import { createContext, useContext } from "react";

import { ProductRoomFormModelContext } from "../../_shared/context/context";

import type { ProductRoomFormModelContextType } from "../../_shared/context/context";

export type ProductExistingRoomFormModelContextType = {
	onUpdate: () => void;
} & ProductRoomFormModelContextType;

export const ProductExistingRoomFormModelContext = createContext<ProductExistingRoomFormModelContextType | null>(null);

export const ProductExistingRoomFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductExistingRoomFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductExistingRoomFormModelContext.Provider value={value}>
			<ProductRoomFormModelContext.Provider value={value}>{children}</ProductRoomFormModelContext.Provider>
		</ProductExistingRoomFormModelContext.Provider>
	);
};

export const useProductExistingRoomFormModelContext = () => {
	const context = useContext(ProductExistingRoomFormModelContext);

	if (!context) {
		throw new Error(
			"useProductExistingRoomFormModelContext must be used within a ProductExistingRoomFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
